import { LocalizationProvider as OgLocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import React from 'react';

export const LocalizationProvider = ({ children }: { children: React.ReactElement }) => <OgLocalizationProvider dateAdapter={AdapterDateFns}>{children}</OgLocalizationProvider>;
